import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Req } from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler} from '@gtpl/shared-utils/error-messages';
import { AdvancedConsoleLogger } from 'typeorm';
import { PinoLogger, InjectPinoLogger } from 'nestjs-pino';
import { request } from 'https';
import { LogsService } from './logs.service';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
@ApiTags('Logs')
@Controller('logs')
export class LogsController {
  constructor(private logsService: LogsService){}
  @Post('/getLogs')
  async getLogs(): Promise<any> {
    try {
      return await this.logsService.getLogs();
    } catch (error) {
     throw new ErrorResponse(11106,'Logs not retrieved');
    }
  }
}
